import React, { createContext, useState, useContext } from 'react';

interface ProfilePageValidationContextType {
  isPageValidated: (page: string) => boolean;
  setPageValidated: (page: string, isValid: boolean) => void;
}

const ProfilePageValidationContext = createContext<ProfilePageValidationContextType | undefined>(undefined);

export const ProfilePageValidationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [validatedPages, setValidatedPages] = useState<Record<string, boolean>>({});

  const isPageValidated = (page: string) => validatedPages[page] ?? true; // Using the validation hook is not required for all pages.

  const setPageValidated = (page: string, isValid: boolean) => {
    setValidatedPages(prev => ({ ...prev, [page]: isValid }));
  };

  return (
    <ProfilePageValidationContext.Provider value={{ isPageValidated, setPageValidated }}>
      {children}
    </ProfilePageValidationContext.Provider>
  );
};

export const useProfilePageValidationOptional = () => {
  return useContext(ProfilePageValidationContext) 
    ?? { isPageValidated: () => true, setPageValidated: () => {} };
};

export const useProfilePageValidation = () => {
  const context = useContext(ProfilePageValidationContext);
  if (context === undefined) {
    throw new Error('useProfilePageValidation must be used within a ProfilePageValidationProvider');
  }
  return context;
};